export type OrientationMode = 'map' | 'fixed' | 'screen';

/** Ce que le réglage écrit sur un texte ou une image (`rotation`, `rotateWithMap`). */
export type OrientationValues = { rotation?: number; rotateWithMap?: boolean; };

export const orientationModeOf = (values: OrientationValues | undefined): OrientationMode => {
	if (values?.rotateWithMap) return 'screen';

	return values?.rotation === undefined ? 'map' : 'fixed';
};
